<div class="dark-blue">
  <nestas-toolbar [steps]="steps"></nestas-toolbar>
</div>
<div class="wrap profile-component">
  <div class="alert-info alert-info-margin">
    <i class="material-icons ic-info">info</i>
    <div>
      <span *ngIf="!me.company" class="highlight">{{translate.instant('PROFILE.PID_COUNT')}}:&nbsp;{{me.nbPID}}/{{me.PIDLimit}}</span>
      <span *ngIf="me.company" class="highlight">{{translate.instant('PROFILE.PID_COUNT')}}:&nbsp;{{me.nbPID}} ({{me.nbPIDTotal}}/{{me.PIDLimit}})</span>
      <br />
      <span>
        <a href="mailto:contact@nestas.eu" class="link" title="{{translate.instant('MESSAGE.SEND_EMAIL')}}">
          {{translate.instant('PROFILE.MORE_PID')}}.
        </a>
      </span>
    </div>
  </div>
  <mat-card>
    <mat-card-title>{{translate.instant('PROFILE.MY_INFORMATION')}}</mat-card-title>
    <div class="info-group">
      <mat-form-field>
        <input matInput [(ngModel)]="me.firstname" type="text" placeholder="{{translate.instant('DATA.FIRSTNAME')}}">
      </mat-form-field>
      <mat-form-field>
        <input matInput [(ngModel)]="me.lastname" type="text" placeholder="{{translate.instant('DATA.LASTNAME')}}">
      </mat-form-field>
    </div>
    <div class="info-group" *ngIf="me.address">
      <mat-card-subtitle>{{translate.instant('DATA.ADDRESS')}}</mat-card-subtitle>
      <mat-form-field>
        <input matInput [(ngModel)]="me.address.address" type="text" placeholder="{{translate.instant('DATA.STREET_AND_NUMBER')}}">
      </mat-form-field>
      <mat-form-field>
        <input matInput [(ngModel)]="me.address.zip" type="number" placeholder="{{translate.instant('DATA.ZIP')}}">
      </mat-form-field>
      <mat-form-field>
        <input matInput [(ngModel)]="me.address.city" type="text" placeholder="{{translate.instant('DATA.CITY')}}">
      </mat-form-field>
      <mat-form-field>
        <input matInput [(ngModel)]="me.address.country" type="text" placeholder="{{translate.instant('DATA.COUNTRY')}}">
      </mat-form-field>
    </div>
    <div class="info-group">

      <mat-form-field>
        <input matInput [(ngModel)]="me.phone" type="text" placeholder="{{translate.instant('DATA.PHONE')}}">
      </mat-form-field>
      <!-- TODO: Remove (keypressed) when mat-input matInput readonly fixed -->
      <mat-form-field>
        <input matInput [(ngModel)]="me.email" type="text" placeholder="{{translate.instant('DATA.EMAIL')}}" [readOnly]="true"
          (mouseenter)="hint.email = true;" (mouseleave)="hint.email = false;">
        <mat-hint *ngIf="hint.email" align="end">{{translate.instant('MESSAGE.CANNOT_MODIFY_EMAIL')}}</mat-hint>
      </mat-form-field>

    </div>
    <label>{{translate.instant('DATA.SENDFROMOPTION')}}</label>

    <div class="info-group">

      <div class="mat-input-hint-spacer mat-form-field-hint-spacer"></div>

      <mat-card-subtitle class="text-left dosendfrom">{{translate.instant('DATA.DOSENDFROM')}}</mat-card-subtitle>
      <select [(ngModel)]="me.useFromEmail" (change)="updateUseFromEmail($event.target.value)">
        <option [ngValue]="true">Ja</option>
        <option [ngValue]="false">Nee</option>
      </select>

    </div>

    <div class="info-group">

      <div *ngIf="me.useFromEmail">
        <mat-form-field>
          <input matInput [(ngModel)]="me.fromEmail" type="text" placeholder="{{translate.instant('DATA.FROMEMAIL')}}">
        </mat-form-field>

        <span *ngIf="me.fromEmailVerified">{{translate.instant('DATA.EMAILVERIFIED')}}</span>
        <span *ngIf="!me.fromEmailVerified">{{translate.instant('DATA.EMAIL_NOT_VERIFIED')}}</span>
      </div>

    </div>

    <div class="info-group">
      <!--<input #file type="file" [hidden]="true" accept="image/*" (change)="uploadLogo(file.files)">
      <button mat-button #upload (click)="file.click()">{{translate.instant('DATA.LOGO')}}</button>-->

      <label for='file' class="select-label">{{translate.instant('NEW_PID.PICTURE')}}:</label>

      <img #imgPreview *ngIf="me.logo && me.logo.fileName" [src]="me.logo.url" class="preview-logo" />
      <mat-card-subtitle class="text-left logo">{{translate.instant('NEW_PID.LOGO_INSTRUCTIONS')}}</mat-card-subtitle>
      <input type="file" accept=".gif, .jpg, .jpeg, .png" name='file' id='file' (change)="fileChangeEvent($event)">

    </div>
    <br>
    <div align="end">
      <button mat-raised-button (click)="updateInformation()" color="primary">
        {{translate.instant('BUTTON.ACTION.UPDATE')}}
      </button>
    </div>
  </mat-card>
</div>